<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Create {{ utils.getLangTerm('ta-jsa-swms.singular', 'TA/JSA/SWMS') }}</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #form="ngForm" (ngSubmit)="onSubmit(form)">

  <hr class="m-0 p-0">

  <mat-dialog-content class="py-4">

    <div class="row">
      <div class="col-12">
        <mat-form-field class="mb-3" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('ta-jsa-swms.fields.task_name.label', 'Name') }}</mat-label>
          <input
            matInput
            [placeholder]="utils.getLangTerm('ta-jsa-swms.fields.task_name.label', 'Name')"
            [(ngModel)]="ta_revised.task_name"
            name="task_name"
            type="text"
            required
            #task_name
            [matTooltip]="utils.getLangTerm('ta-jsa-swms.fields.task_name.hint', 'Please enter a name.')" />
          <mat-hint>{{ utils.getLangTerm('ta-jsa-swms.fields.task_name.hint', 'Please enter a name.') }}</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-xl-6">
        <mat-form-field class="mb-3" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('ta-jsa-swms.fields.task_description.label', 'Description') }}</mat-label>
          <textarea
            rows="4"
            matInput
            [placeholder]="utils.getLangTerm('ta-jsa-swms.fields.task_description.label', 'Description')"
            [(ngModel)]="ta_revised.task_description"
            name="task_description"
            required
            #task_description
            [matTooltip]="utils.getLangTerm('ta-jsa-swms.fields.task_description.hint', 'Please enter a description.')">
          </textarea>
          <mat-hint>{{ utils.getLangTerm('ta-jsa-swms.fields.task_description.hint', 'Please enter a description.') }}</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-12 col-xl-6">
        <mat-form-field class="mb-3" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('ta-jsa-swms.fields.work_procedure.label', 'Work Procedure') }}</mat-label>
          <textarea
            rows="4"
            matInput
            [placeholder]="utils.getLangTerm('ta-jsa-swms.fields.work_procedure.label', 'Work Procedure')"
            [(ngModel)]="ta_revised.work_procedure"
            name="work_procedure"
            #work_procedure>
          </textarea>
          <mat-hint>{{ utils.getLangTerm('ta-jsa-swms.fields.work_procedure.hint', 'Enter the Work Procedures.') }}</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-xl-6">
        <mat-form-field class="mb-3" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('ta-jsa-swms.fields.training_qualifications.label', 'Training/Qualifications') }}</mat-label>
          <textarea
            rows="4"
            matInput
            [placeholder]="utils.getLangTerm('ta-jsa-swms.fields.training_qualifications.label', 'Training/Qualifications')"
            [(ngModel)]="ta_revised.training_qualifications"
            name="training_qualifications"
            #training_qualifications>
          </textarea>
          <mat-hint>{{ utils.getLangTerm('ta-jsa-swms.fields.training_qualifications.hint', 'Enter the Training/Qualifications needed. (Seperated by a new line)') }}</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-12 col-xl-6">
        <mat-form-field class="mb-3" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('ta-jsa-swms.fields.duties.label', 'Duties') }}</mat-label>
          <textarea
            rows="4"
            matInput
            [placeholder]="utils.getLangTerm('ta-jsa-swms.fields.duties.label', 'Duties')"
            [(ngModel)]="ta_revised.duties"
            name="duties"
            #duties>
          </textarea>
          <mat-hint>{{ utils.getLangTerm('ta-jsa-swms.fields.duties.hint', 'Enter the Duties to undertake. (Seperated by a new line)') }}</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-xl-6">
        <mat-form-field class="mb-3" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('ta-jsa-swms.fields.certificates.label', 'Certificates of Competency') }}</mat-label>
          <textarea
            rows="4"
            matInput
            [placeholder]="utils.getLangTerm('ta-jsa-swms.fields.certificates.label', 'Certificates of Competency')"
            [(ngModel)]="ta_revised.certificates"
            name="certificates"
            #certificates>
          </textarea>
          <mat-hint>{{ utils.getLangTerm('ta-jsa-swms.fields.certificates.hint', 'Enter the Certificates of Competency required. (Seperated by a new line)') }}</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-12 col-xl-6">
        <mat-form-field class="mb-3" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('ta-jsa-swms.fields.emergency_arrangements.label', 'Emergency Procedures') }}</mat-label>
          <textarea
            rows="4"
            matInput
            [placeholder]="utils.getLangTerm('ta-jsa-swms.fields.emergency_arrangements.label', 'Emergency Procedures')"
            [(ngModel)]="ta_revised.emergency_arrangements"
            name="emergency_arrangements"
            #emergency_arrangements>
          </textarea>
          <mat-hint>{{ utils.getLangTerm('ta-jsa-swms.fields.emergency_arrangements.hint', 'Enter the emergency arrangements for this work.') }}</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-xl-6">
        <mat-form-field class="mb-3" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('ta-jsa-swms.fields.code_of_practice.label', 'Code of Practice') }}</mat-label>
          <textarea
            rows="4"
            matInput
            [placeholder]="utils.getLangTerm('ta-jsa-swms.fields.code_of_practice.label', 'Code of Practice')"
            [(ngModel)]="ta_revised.code_of_practice"
            name="code_of_practice"
            #code_of_practice>
          </textarea>
          <mat-hint>{{ utils.getLangTerm('ta-jsa-swms.fields.code_of_practice.hint', 'Enter the Code of Practice. (Seperated by a new line)') }}</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-12 col-xl-6">
        <mat-form-field class="mb-3" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('ta-jsa-swms.fields.maintenance_checks.label', 'Maintenance Checks') }}</mat-label>
          <textarea
            rows="4"
            matInput
            [placeholder]="utils.getLangTerm('ta-jsa-swms.fields.maintenance_checks.label', 'Maintenance Checks')"
            [(ngModel)]="ta_revised.maintenance_checks"
            name="maintenance_checks"
            #maintenance_checks>
          </textarea>
          <mat-hint>{{ utils.getLangTerm('ta-jsa-swms.fields.maintenance_checks.hint', 'Enter the Maintenance Checks required. (Seperated by a new line)') }}</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-xl-6">
        <mat-form-field class="mb-3" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('ta-jsa-swms.fields.safety_practices.label', 'Safety Practice') }}</mat-label>
          <textarea
            rows="4"
            matInput
            [placeholder]="utils.getLangTerm('ta-jsa-swms.fields.safety_practices.label', 'Safety Practice')"
            [(ngModel)]="ta_revised.safety_practices"
            name="safety_practices"
            #safety_practices>
          </textarea>
          <mat-hint>{{ utils.getLangTerm('ta-jsa-swms.fields.safety_practices.hint', 'Enter the Safety Practices. (Seperated by a new line)') }}</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-12 col-xl-6">
        <mat-form-field class="mb-3" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('ta-jsa-swms.fields.ppe_other.label', 'PPE Other') }}</mat-label>
          <textarea
            rows="4"
            matInput
            [placeholder]="utils.getLangTerm('ta-jsa-swms.fields.ppe_other.label', 'PPE Other')"
            [(ngModel)]="ta_revised.ppe_other"
            name="ppe_other"
            #ppe_other>
          </textarea>
          <mat-hint>{{ utils.getLangTerm('ta-jsa-swms.fields.ppe_other.hint', 'Enter the Other PPE required. (Seperated by a new line)') }}</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-xl-6">
        <mat-form-field class="mb-3" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('ta-jsa-swms.fields.work_permits_other.label', 'Work Permits Other') }}</mat-label>
          <textarea
            rows="4"
            matInput
            [placeholder]="utils.getLangTerm('ta-jsa-swms.fields.work_permits_other.label', 'Work Permits Other')"
            [(ngModel)]="ta_revised.work_permits_other"
            name="work_permits_other"
            #work_permits_other>
          </textarea>
          <mat-hint>{{ utils.getLangTerm('ta-jsa-swms.fields.work_permits_other.hint', 'Enter Other Work Permits required. (Seperated by a new line)') }}</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-12 col-xl-6">
        <mat-form-field class="mb-3" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('ta-jsa-swms.fields.tools_other.label', 'Tools Other') }}</mat-label>
          <textarea
            rows="4"
            matInput
            [placeholder]="utils.getLangTerm('ta-jsa-swms.fields.tools_other.label', 'Tools Other')"
            [(ngModel)]="ta_revised.tools_other"
            name="tools_other"
            #tools_other>
          </textarea>
          <mat-hint>{{ utils.getLangTerm('ta-jsa-swms.fields.tools_other.hint', 'Enter Other Tools required. (Seperated by a new line)') }}</mat-hint>
        </mat-form-field>
      </div>
    </div>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="p-3">

    <button
      type="button"
      mat-raised-button
      color="secondary"
      (click)="onSelectApprover()"
      [matBadge]="'' + (ta_revised.approver_id ? 1 : 0)"
      class="my-2 ml-1 mr-2"
      matTooltip="Select an approver.">
      <mat-icon>rate_review</mat-icon>
      {{ !ta_revised.approver_id ? 'Select' : 'Change' }} Approver
    </button>

    <button
      type="button"
      mat-raised-button
      color="secondary"
      (click)="onSelectAuthorizer()"
      [matBadge]="'' + (ta_revised.authorizer_id ? 1 : 0)"
      class="my-2 ml-1 mr-2"
      matTooltip="Select an authorizer.">
      <mat-icon>rate_review</mat-icon>
      {{ !ta_revised.authorizer_id ? 'Select' : 'Change' }} Authorizer
    </button>

    <button
      mat-raised-button
      type="button"
      color="secondary"
      (click)="onSelectSupervisor()"
      [matBadge]="'' + (ta_revised.supervisor_id ? 1 : 0)"
      class="my-2 ml-1 mr-2"
      matTooltip="Select a supervisor">
      <mat-icon>person</mat-icon>
      {{ !ta_revised.supervisor_id ? 'Select' : 'Change' }} Supervisor
    </button>

    <button
      mat-raised-button
      type="button"
      (click)="onSelectUsers()"
      [matBadge]="'' + (ta_revised.user_ids ? ta_revised.user_ids?.length : 0)"
      class="my-2 ml-1 mr-2"
      color="secondary"
      matTooltip="Select Assignees from the Users selection list.">
      <mat-icon>people</mat-icon>
      Assignees
    </button>

    <div class="w-100"></div>

    <button
      mat-raised-button
      [disabled]="!form.valid || inProgress"
      color="primary"
      type="button"
      id="save"
      class="my-2 ml-1 mr-2"
      (click)="onSubmit(form)">
      <mat-icon>save</mat-icon>
      Save & Close
    </button>

    <button
      mat-raised-button
      [disabled]="!form.valid || inProgress"
      color="primary"
      type="button"
      id="continue"
      class="my-2 ml-1 mr-2"
      (click)="onSubmit(form, true)"
      *ngIf="canEdit">
      <mat-icon>save</mat-icon>
      Save & Continue
    </button>

    <app-file-browse-button
      *ngIf="!ta_revised.clone_from_id"
      (selectedFiles)="onSelectFiles($event)"
      (afterDialogClosedEvent)="onSubmit(form)"
      parentObjectType="task_analysis_revised"
      [parentObjectId]="ta_revised.id"
      [filesCount]="ta_revised.files?.length">
    </app-file-browse-button>

    <button
      mat-raised-button
      type="button"
      (click)="onSelectAssets()"
      [matBadge]="'' + (ta_revised.asset_ids ? ta_revised.asset_ids?.length : 0)"
      class="my-2 ml-1 mr-2"
      color="secondary"
      matTooltip="Select Assets from the Assets selection list.">
      <mat-icon>forklift</mat-icon>
      Assets
    </button>

    <button
      mat-raised-button
      type="button"
      (click)="selectPPE()"
      [matBadge]="'' + (ta_revised.ppe_ids ? ta_revised.ppe_ids?.length : 0)"
      class="my-2 ml-1 mr-2"
      color="secondary"
      matTooltip="Select PPE from the PPE selection list.">
      <mat-icon>headset</mat-icon>
      PPE
    </button>

    <button
      mat-raised-button
      type="button"
      (click)="selectWorkPermits()"
      [matBadge]="'' + (ta_revised.work_permit_ids ? ta_revised.work_permit_ids?.length : 0)"
      class="my-2 ml-1 mr-2"
      color="secondary"
      matTooltip="Select Work Permits from the Work Permits selection list.">
      <mat-icon>assignment_ind</mat-icon>
      Work Permits
    </button>

    <button
      mat-raised-button
      type="button"
      (click)="selectTools()"
      [matBadge]="'' + (ta_revised.tool_ids ? ta_revised.tool_ids?.length : 0)"
      class="my-2 ml-1 mr-2"
      color="secondary"
      matTooltip="Select Tools from the Tools selection list.">
      <mat-icon>build</mat-icon>
      Tools
    </button>

    <button
      mat-raised-button
      type="button"
      (click)="onSelectHazardousSubstances()"
      [matBadge]="'' + (ta_revised.hazardous_substance_ids ? ta_revised.hazardous_substance_ids?.length : 0)"
      class="my-2 ml-1 mr-2"
      color="secondary"
      matTooltip="Select {{ utils.getLangTerm('hazardous-substances.plural', 'Hazardous Substances') }} linked to this {{ utils.getLangTerm('ta-jsa-swms.singular', 'TA/JSA/SWMS Document') }}.">
      <mat-icon>science</mat-icon>
      {{ utils.getLangTerm('hazardous-substances.plural', 'Hazardous Substances') }}
    </button>

  </mat-dialog-actions>

</form>


